import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {OrbitaxExcelMemoConfig} from './orbitax-excel-memo.config';
import {Configuration} from '@shared/models/configuration';
import { DialogModel } from '@shared/models/dialog.model';
import { DialogService } from '@shared/services/dialog-service';
import { PlatformCommand } from '@shared/commands/command-base';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { MemoInfo } from './models/memo-info';

@Injectable({
  providedIn: 'root'
})
export class OrbitaxExcelMemoService {

  constructor(private httpClient: HttpClient,
    private dialogService: DialogService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private commandService: CommandService) {
  }

  getRateMemoCount(type: string): Observable<number> {
    return this.httpClient.get<number>(`${Configuration.ITRCEApi}Memo/GetRateMemoCount?type=${type}&projectId=[PROJECT_ID]`);
  }

  getExcelMemoCount(type: string): Observable<number> {
    return this.httpClient.get<number>(`${Configuration.ITRCEApi}Memo/GetExcelMemoCount?type=${type}&projectId=[PROJECT_ID]`);
  }
  getExcelMemo(id: string, currentMemoInfo: any = {}): Observable<any> {
    return this.httpClient.post<any>(OrbitaxExcelMemoConfig.GetExcelMemoApi(id), currentMemoInfo);
  }

  viewMemo(id: string, memoType: string): Observable<string> {
    return this.httpClient.get<string>(OrbitaxExcelMemoConfig.ViewMemoApi(id, memoType), {responseType: 'text' as 'json'});
  }

  getPaymentStream(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${Configuration.ITRCEApi}Memo/RateSteams`    );
  }

  getCoporateTaxMemoByCountryCode(countryCode: string): Observable<any> {
    return this.httpClient.get<any>(`${OrbitaxExcelMemoConfig.ITRCEApi}Memo/CorporateTaxMemoByCountryCode?id=${countryCode}`);
  }

  getCorporateTaxMemo(id: string): Observable<any> {
    return this.httpClient.get<any>(OrbitaxExcelMemoConfig.GetCoporateTaxMemoApi(id));
  }

  getWithholdingTaxMemo(id: string): Observable<any> {
    return this.httpClient.get<any>(OrbitaxExcelMemoConfig.GetWithholdingTaxMemoApi(id));
  }

  saveWithholdingTaxMemo(id: string, currentMemoInfo: any = {}): Observable<any> {
    return this.httpClient.post<any>(OrbitaxExcelMemoConfig.SaveWithholdingTaxMemoApi(id), currentMemoInfo);
  }

  saveCorporateTaxMemo(id: string, currentMemoInfo: any = {}): Observable<any> {
    return this.httpClient.post<any>(OrbitaxExcelMemoConfig.SaveCorporateTaxMemoApi(id), currentMemoInfo);
  }

  downloadMemo(id: string, memoType: string): Observable<any> {
    return this.httpClient.get<string>(OrbitaxExcelMemoConfig.DownloadMemoApi(id, memoType), {responseType: 'blob' as 'json'});
  }

  showCountryDialgogue(title: string, countryCode: string, callback: Function) {
    const dialogModel = DialogModel.create(
       title,
      'CountrySelectorDialogComponent',
      { selectedCountryCode: countryCode, setDefault: false }
    );
    dialogModel.minWidth = '600px';
    this.dialogService
      .showOkCancelDialog(dialogModel)
      .subscribe((actionState) => {
        console.log(actionState.action);
        if (actionState && actionState.action == 'OK') {
          const country = actionState.data.input.selectedCountry;
          callback(country);
        }
      });
  }

  updateMemoField(memoInfo: MemoInfo, magicLinkModel: any, editedField: {key: string, value: string}, callback: Function) {
    const command = new PlatformCommand('UpdateRateMemoCommand','ITRCEApi');
    command.fieldValues[editedField.key] = editedField.value;
    command.fieldValues['MemoId'] = memoInfo.id;
    command.fieldValues['MemoType'] = memoInfo.type;
    command.projectId = '[PROJECT_ID]';
    command.fieldValues['PlatformLinkId'] = magicLinkModel.id;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).subscribe(response => {
      this.fuseSplashScreenService.hide();
      callback(response);
    });
  }
}


